import gql from "graphql-tag"

export const MORE_BLOG_LIST = gql`
  query moreBlog($where: BlogWhereInput) {
    moreBlog(where: $where) {
      id
      title
      createdAt
      description
      thumbnailUrl
      user {
        id
        firstName
        avatarUrl
        lastName
      }
    }
  }
`

export const BLOG = gql`
  query blog($where: BlogWhereInput) {
    blog(where: $where) {
      id
      title
      metaTitle
      metaDescription
      tag {
        name
      }
      thumbnailUrl
      createdAt
      description
      user {
        id
        firstName
        avatarUrl
        lastName
        bio
      }
    }
  }
`

export const fetchMoreBlogList = async (client, id, authState) => {
  try {
    return await client.query({
      query: MORE_BLOG_LIST,
      variables: {
        where: {
          skip: 0,
          take: 7,
          id,
          userId: authState && authState.state && authState.state.user && authState.state.user.id
        }
      }
    })
  } catch (error) {
    console.log("Error", error)
  }
}

export const fetchBlog = async (client, blogId, isDashboard) => {
  try {
    return await client.query({
      query: BLOG,
      fetchPolicy: isDashboard ? "network-only" : "cache",
      variables: {
        where: {
          id: blogId,
          isDashboard
        }
      }
    })
  } catch (error) {
    console.log("Error", error)
  }
}
